import pro1 from '../assets/Home/pro1.png';
import pro2 from '../assets/Home/pro2.png';
import pro3 from '../assets/Home/pro3.png';
import pro4 from '../assets/Home/pro4.png';
import hero1 from '../assets/Home/Hero1.png';

// Panel Saw 3200A Images
import ps3200aHero from '../assets/Products/PanelSaw3200A/Hero.png';
import ps3200aImg1 from '../assets/Products/PanelSaw3200A/img1.png';
import ps3200aImg2 from '../assets/Products/PanelSaw3200A/img2.png';
import ps3200aImg3 from '../assets/Products/PanelSaw3200A/img3.png';

// Panel Saw 3200A.HV Images
import ps3200aHVHero from '../assets/Products/PanelSaw3200A.HV/Hero.png';
import ps3200aHVImg1 from '../assets/Products/PanelSaw3200A.HV/img1.png';
import ps3200aHVImg2 from '../assets/Products/PanelSaw3200A.HV/img2.png';
import ps3200aHVImg3 from '../assets/Products/PanelSaw3200A.HV/img3.png';

// Panel Saw 3200A++ Images
import ps3200aPlusHero from '../assets/Products/PanelSaw3200A++/Hero.png';
import ps3200aPlusImg1 from '../assets/Products/PanelSaw3200A++/img1.png';
import ps3200aPlusImg2 from '../assets/Products/PanelSaw3200A++/img2.png';
import ps3200aPlusImg3 from '../assets/Products/PanelSaw3200A++/img3.png';

import { categoriesData } from './categoriesData';

export const getRelatedProducts = (currentSlug) => {
  if (!currentSlug) return [];

  const normSlug = currentSlug.toLowerCase().trim();

  // Find the category containing this model slug
  let matchedCatKey = null;
  for (const key in categoriesData) {
    const cat = categoriesData[key];
    if (cat.models && cat.models.some(m => m.slug.toLowerCase().trim() === normSlug)) {
      matchedCatKey = key;
      break;
    }
  }

  // If category found, return all other models from that category
  if (matchedCatKey) {
    const catModels = categoriesData[matchedCatKey].models;
    return catModels
      .filter(m => m.slug.toLowerCase().trim() !== normSlug)
      .map(m => ({
        id: m.id,
        slug: m.slug,
        title: m.name,
        description: m.description,
        image: m.image
      }));
  }

  return [];
};

export const productsData = {
  // 1. Panel Saw 3200 A
  'ups-3200a': {
    slug: 'ups-3200a',
    category: 'PANEL SAW MACHINE',
    title: 'Panel Saw 3200 A',
    subtitle: 'Precision Panel Cutting. Smooth Operation. Reliable Production.',
    mainImage: ps3200aHero,
    detailImage1: ps3200aImg1,
    detailImage2: ps3200aImg2,
    detailImage3: ps3200aImg3,
    breadcrumb: 'HOME / PRODUCTS / PANEL SAW MACHINE / PANEL SAW 3200 A',
    introHeading: 'High-Performance Panel Sawing for Precision Production',
    introText1: 'The Panel Saw 3200 A is designed for accurate and efficient panel cutting, delivering reliable performance for professional woodworking and furniture manufacturing applications.',
    introText2: 'Built to process a wide range of panel materials, the machine supports precise cutting, smooth operation, and consistent results, making it a dependable solution for modern woodworking and panel-processing environments.',
    
    stickyCards: [
      {
        text: 'Designed to deliver accurate and consistent cuts for professional panel-processing applications.',
        title: 'High-Precision Cutting'
      },
      {
        text: 'Engineered for controlled and efficient cutting, helping maintain consistent production workflows.',
        title: 'Smooth Operation'
      },
      {
        fullWidth: true,
        text: 'Suitable for plywood, MDF, particle board, acrylic, and laminated panels.',
        title: 'Versatile Panel Processing'
      }
    ],

    section1: {
      heading: 'Precision Panel Cutting',
      description: 'The Panel Saw 3200 A is engineered to provide accurate and consistent cutting performance across different panel-processing requirements. Its professional design supports clean and controlled cutting for furniture manufacturing and woodworking applications.',
      bullets: [
        { title: 'Accurate Panel Cutting', text: 'Supports precise cutting operations for professional woodworking applications.' },
        { title: 'Consistent Results', text: 'Helps maintain uniform cutting quality across different panel sizes and production requirements.' },
        { title: 'Clean Processing', text: 'Designed to support smooth cutting and quality finishes for furniture and panel manufacturing.' }
      ]
    },

    section2: {
      heading: 'Robust Construction for Continuous Operation',
      description: 'Built for demanding manufacturing environments, the Panel Saw 3200 A combines a strong machine structure with reliable operating performance. The heavy-duty construction provides stability during high-volume cutting operations, while the durable design supports dependable long-term use.',
      bullets: [
        { title: 'Heavy-Duty Build', text: 'Designed to handle demanding cutting operations with stability and reliability.' },
        { title: 'Long-Term Reliability', text: 'Built to support consistent machine performance in professional production environments.' },
        { title: 'Stable Operation', text: 'A robust structure helps maintain dependable cutting performance throughout production.' }
      ]
    },

    section3: {
      heading: 'Versatile Material Processing',
      description: 'Designed for flexible woodworking applications, the Panel Saw 3200 A can be used for processing various commonly used panel materials. This versatility makes it suitable for different furniture and interior manufacturing requirements.',
      bullets: [
        { title: 'Plywood', text: 'Suitable for accurate cutting and processing of plywood panels.' },
        { title: 'MDF & Particle Board', text: 'Designed to support efficient processing of engineered wood materials.' },
        { title: 'Acrylic & Laminated Panels', text: 'Suitable for cutting a range of finished and laminated panel materials.' }
      ]
    }
  },

  // 2. Panel Saw 3200 A.HV
  'ups-3200a-hv': {
    slug: 'ups-3200a-hv',
    category: 'PANEL SAW MACHINE',
    title: 'Panel Saw 3200 A.HV',
    subtitle: 'Precision Panel Cutting. Smooth Operation. Reliable Production.',
    mainImage: ps3200aHVHero,
    detailImage1: ps3200aHVImg1,
    detailImage2: ps3200aHVImg2,
    detailImage3: ps3200aHVImg3,
    breadcrumb: 'HOME / PRODUCTS / PANEL SAW MACHINE / PANEL SAW 3200 A.HV',
    introHeading: 'High-Performance Panel Sawing for Precision Production',
    introText1: 'The Panel Saw 3200 A.HV is designed for precise and efficient panel processing, delivering reliable cutting performance for professional woodworking and furniture manufacturing applications.',
    introText2: 'Built to handle a wide range of panel materials, the machine supports accurate and consistent cutting while providing smooth operation and dependable performance for demanding production environments.',
    
    stickyCards: [
      {
        text: 'Designed to deliver accurate panel cuts with consistent results across production requirements.',
        title: 'Precision Cutting'
      },
      {
        text: 'Engineered for dependable and controlled operation during professional panel processing.',
        title: 'Smooth Operation'
      },
      {
        fullWidth: true,
        text: 'Suitable for processing plywood, MDF, particle board, acrylic, and laminated panels.',
        title: 'Versatile Panel Processing'
      }
    ],

    section1: {
      heading: 'Precision Panel Cutting',
      description: 'The Panel Saw 3200 A.HV is built to support accurate panel cutting for furniture and woodworking applications. Its design focuses on consistent cutting performance, helping manufacturers achieve clean and reliable results throughout production.',
      bullets: [
        { title: 'Accurate Cutting', text: 'Supports precise cutting operations for professional panel processing.' },
        { title: 'Consistent Results', text: 'Helps maintain uniform cutting quality across different panels and production requirements.' },
        { title: 'Professional Processing', text: 'Designed for woodworking and furniture manufacturing environments where precision is essential.' }
      ]
    },

    section2: {
      heading: 'Versatile Material Processing',
      description: 'The Panel Saw 3200 A.HV is suitable for a broad range of panel materials used in modern woodworking and furniture production. Its versatile cutting capability makes it suitable for different manufacturing applications.',
      bullets: [
        { title: 'Plywood', text: 'Suitable for accurate processing of plywood panels.' },
        { title: 'MDF & Particle Board', text: 'Designed to support efficient cutting of commonly used engineered wood panels.' },
        { title: 'Acrylic & Laminated Panels', text: 'Suitable for processing acrylic and laminated panel materials.' }
      ]
    },

    section3: {
      heading: 'Built for Smooth, Reliable Production',
      description: 'Designed for professional woodworking environments, the Panel Saw 3200 A.HV combines dependable operation with consistent cutting performance. Its capabilities make it a practical solution for furniture manufacturers, carpenters, and woodworking units looking for reliable panel-processing equipment.',
      bullets: [
        { title: 'Smooth Operation', text: 'Designed to support controlled and efficient cutting processes.' },
        { title: 'Reliable Performance', text: 'Provides dependable performance for regular woodworking and panel-processing requirements.' },
        { title: 'Long-Term Productivity', text: 'Built to support consistent production and efficient material processing.' }
      ]
    }
  },

  // 3. Panel Saw 3200 A++
  'ups-3200a-plus': {
    slug: 'ups-3200a-plus',
    category: 'PANEL SAW MACHINE',
    title: 'Panel Saw 3200 A++',
    subtitle: 'Precision Cutting. Smooth Operation. Reliable Production.',
    mainImage: ps3200aPlusHero,
    detailImage1: ps3200aPlusImg1,
    detailImage2: ps3200aPlusImg2,
    detailImage3: ps3200aPlusImg3,
    breadcrumb: 'HOME / PRODUCTS / PANEL SAW MACHINE / PANEL SAW 3200 A++',
    introHeading: 'High-Performance Panel Saw Machine — Precision Cutting for Modern Production',
    introText1: 'The Panel Saw 3200 A++ is designed for professional panel cutting applications, delivering precise, consistent, and efficient performance for woodworking and furniture manufacturing. Its robust design supports reliable cutting operations while maintaining accuracy across different production requirements.',
    introText2: 'Designed to process materials such as plywood, MDF, particle board, acrylic, and laminated panels, the Panel Saw 3200 A++ provides smooth and controlled cutting performance. It is well suited for furniture manufacturers, carpenters, and professional woodworking environments where precision and dependable operation are essential.',
    
    stickyCards: [
      {
        text: 'Designed to deliver accurate and consistent panel cuts for professional woodworking applications.',
        title: 'High Precision Cutting'
      },
      {
        text: 'Built to support stable operation and dependable performance in demanding production environments.',
        title: 'Reliable Construction'
      },
      {
        fullWidth: true,
        text: 'Helps streamline cutting workflows for improved productivity and consistent production output.',
        title: 'Efficient Panel Processing'
      }
    ],

    section1: {
      heading: 'High-Precision Panel Cutting',
      description: 'The Panel Saw 3200 A++ is engineered to provide accurate and consistent cutting performance across a range of panel-processing applications. Its professional cutting system helps achieve clean results while maintaining control throughout the cutting process.',
      bullets: [
        { title: 'Accurate Panel Cutting', text: 'Supports precise cutting for furniture and woodworking applications.' },
        { title: 'Consistent Results', text: 'Helps maintain uniform cutting quality across different panel sizes and production requirements.' },
        { title: 'Clean Cutting Performance', text: 'Designed for controlled processing and quality panel finishes.' }
      ]
    },

    section2: {
      heading: 'Versatile Material Processing',
      description: 'The Panel Saw 3200 A++ is designed to handle a variety of commonly used woodworking and panel materials. Its versatile application makes it suitable for furniture manufacturing, interior production, and professional woodworking operations.',
      bullets: [
        { title: 'Plywood', text: 'Suitable for accurate processing of plywood panels.' },
        { title: 'MDF & Particle Board', text: 'Supports efficient cutting of commonly used engineered wood materials.' },
        { title: 'Acrylic & Laminated Panels', text: 'Designed to process finished and laminated panel materials with controlled cutting performance.' }
      ]
    },

    section3: {
      heading: 'Built for Smooth, Reliable Production',
      description: 'Designed for demanding manufacturing environments, the Panel Saw 3200 A++ combines heavy-duty construction with reliable operating performance. Its stable structure supports consistent cutting accuracy during high-volume production operations.',
      bullets: [
        { title: 'Heavy-Duty Construction', text: 'Built with a rigid frame and cast-iron components for stability and vibration-free cutting.' },
        { title: 'Long-Term Reliability', text: 'Designed for continuous industrial production with dependable mechanical drives.' },
        { title: 'Stable & Smooth Operation', text: 'High-precision sliding carriage delivers effortless movement and repeatable accuracy.' }
      ]
    }
  },

  // 4. Auto CNC Beam Saw (UBS 2800)
  'ubs-2800-auto': {
    slug: 'ubs-2800-auto',
    category: 'AUTO CNC BEAM SAW',
    title: 'Auto Beam Saw UBS 2800',
    subtitle: 'Precision Cutting. Consistent Performance. Efficient Production.',
    mainImage: pro1,
    detailImage1: pro1,
    detailImage2: pro2,
    detailImage3: pro3,
    breadcrumb: 'HOME / PRODUCTS / CNC BEAM SAW / UBS 2800',
    introHeading: 'Built for Precision. Designed for Production.',
    introText1: 'The UBS 2800 CNC Automatic Beam Saw combines precision cutting, reliable automation, and robust construction to support high-volume panel processing. Its CNC-controlled operation helps reduce manual intervention while maintaining accuracy and consistency throughout production.',
    introText2: 'Designed for professional woodworking and panel-processing applications, the machine provides a dependable solution for manufacturers looking to improve productivity, cutting quality, and operational efficiency.',
    
    stickyCards: [
      {
        text: 'Accurate and consistent beam sawing for demanding panel-processing applications.',
        title: 'High-Precision Cutting'
      },
      {
        text: 'A robust machine structure designed for stable operation and long-term reliability.',
        title: 'Heavy-Duty Construction'
      },
      {
        fullWidth: true,
        text: 'Automated CNC operation helps reduce manual intervention and streamline production workflows.',
        title: 'Production Efficiency'
      }
    ],

    section1: {
      heading: 'High-Precision Cutting',
      description: 'The UBS 2800 is engineered to deliver accurate and consistent cutting performance across different production requirements.',
      bullets: [
        { title: 'Accurate Beam Sawing', text: 'Advanced CNC-controlled operation helps achieve precise cuts for high-quality panel processing.' },
        { title: 'Consistent Results', text: 'Maintains reliable cutting quality across different batches and panel sizes.' },
        { title: 'Reduced Manual Intervention', text: 'Automated operation helps simplify the cutting process and improve production consistency.' }
      ]
    },

    section2: {
      heading: 'Robust Construction for Continuous Operation',
      description: 'Built for demanding manufacturing environments, the UBS 2800 combines a strong machine structure with reliable operating performance. The heavy-duty construction provides stability during high-volume cutting operations, while the durable design supports dependable long-term use.',
      bullets: [
        { title: 'Heavy-Duty Build', text: 'Designed to handle demanding cutting operations with stability and reliability.' },
        { title: 'Long-Term Reliability', text: 'Built for continuous production environments where consistent machine performance is essential.' },
        { title: 'Stable Operation', text: 'A robust structure helps maintain dependable cutting performance throughout production.' }
      ]
    },

    section3: {
      heading: 'Versatile Material & Batch Processing',
      description: 'Engineered for flexible multi-sheet processing across different panel substrates including MDF, particle board, plywood, and laminated sheets.',
      bullets: [
        { title: 'Multi-Sheet Sizing', text: 'Supports multi-layer cutting to maximize production output per cycle.' },
        { title: 'Substrate Flexibility', text: 'Smooth cutting across laminated surfaces, solid veneers, and engineered composites.' },
        { title: 'Optimized Workflow', text: 'Automated pusher positioning speeds up batch manufacturing and minimizes scrap.' }
      ]
    }
  },

  // 5. CNC Router (UCR 1325 A)
  'ucr-1325-a': {
    slug: 'ucr-1325-a',
    category: 'CNC ROUTER',
    title: 'CNC Router Machine UCR 1325 A',
    subtitle: 'Advanced Routing Solutions for Wood, Acrylic, MDF & Composites.',
    mainImage: pro2,
    detailImage1: pro2,
    detailImage2: pro3,
    detailImage3: pro4,
    breadcrumb: 'HOME / PRODUCTS / CNC ROUTER / UCR 1325 A',
    introHeading: 'Versatile 3D Engraving & Heavy Panel Cutting.',
    introText1: 'The UCR 1325 A CNC Router offers high-speed spindle operations combined with a vacuum matrix bed to secure workpieces for intricate carving, nesting, and 2D/3D cutting.',
    introText2: 'Engineered for signage, furniture carving, architectural panels, and aluminum composite fabrication.',
    
    stickyCards: [
      {
        text: 'High RPM air-cooled spindle for rapid engraving and smooth edge routing.',
        title: 'High-Precision Performance'
      },
      {
        text: 'Heavy steel gantry and rack-pinion drive for vibration-free motion control.',
        title: 'Heavy-Duty Frame'
      },
      {
        fullWidth: true,
        text: 'Vacuum zone table holds complex shapes without mechanical clamps.',
        title: 'Production Efficiency'
      }
    ],

    section1: {
      heading: 'High-Speed Spindle & Motion Control',
      description: 'Features high-resolution stepper/servo drives on all axes with linear guide rails for repeatable precision.',
      bullets: [
        { title: 'High-Speed Spindle', text: 'Delivers high torque for continuous cutting through thick MDF and hardwoods.' },
        { title: 'Multi-Zone Vacuum Table', text: 'Provides localized holding force for small and large panels.' },
        { title: 'DSP Hand Controller', text: 'User-friendly interface for offline G-code execution.' }
      ]
    },

    section2: {
      heading: 'Rigid Structure for Long-Term Reliability',
      description: 'Manufactured with seamless steel welding and stress-relieved frames for maximum longevity.',
      bullets: [
        { title: 'Reinforced Tubular Frame', text: 'Guarantees structural rigidity during heavy high-speed passes.' },
        { title: 'Dust Collection Shroud', text: 'Captures dust at the tool point to protect rails and electronic drives.' },
        { title: 'Reliable Inverter Drive', text: 'Maintains uniform RPM under variable cutter loads.' }
      ]
    },

    section3: {
      heading: 'Wide Material Application & Multi-Industry Use',
      description: 'Provides dependable routing and cutting across wood, acrylic, PVC, foam boards, aluminum composite panels, and solid surfaces.',
      bullets: [
        { title: 'Solid Wood & MDF Carving', text: 'High precision 2D/3D engraving for architectural and furniture applications.' },
        { title: 'Acrylic & Plastic Fabrication', text: 'Polished cut edges for signage, display units, and custom fixtures.' },
        { title: 'Composite Material Sizing', text: 'High-speed cutting with accurate dimensional repeatability.' }
      ]
    }
  },

  // 6. Edge Bander (DEB 240S)
  'deb-240s': {
    slug: 'deb-240s',
    category: 'EDGE BANDER',
    title: 'Edge Bander Machine DEB 240S',
    subtitle: 'Efficient Automated Edge Banding with Precise Finishing.',
    mainImage: pro3,
    detailImage1: pro3,
    detailImage2: pro1,
    detailImage3: pro4,
    breadcrumb: 'HOME / PRODUCTS / EDGE BANDER / DEB 240S',
    introHeading: 'Seamless Edge Sealing for Cabinetry & Modular Furniture.',
    introText1: 'The DEB 240S delivers automated glue application, end trimming, flush trimming, and buffing in one continuous feed passage.',
    introText2: 'Ideal for small-to-medium cabinet makers wanting clean edges on PVC, ABS, melamine, and wood veneer tapes.',
    
    stickyCards: [
      {
        text: 'Automated glue pot heating and uniform adhesive application rollers.',
        title: 'Precision Gluing'
      },
      {
        text: 'Precision trimming motors ensure chip-free top and bottom edge radius.',
        title: 'Clean Finishing'
      },
      {
        fullWidth: true,
        text: 'Feed track system supports continuous high-speed panel edge processing.',
        title: 'Production Speed'
      }
    ],

    section1: {
      heading: 'Multi-Stage Automated Edge Finishing',
      description: 'Equipped with pre-heating, hot-melt gluing, pneumatic end-cutting saws, and radius trimming units.',
      bullets: [
        { title: 'Dual-Blade End Cutting', text: 'Cuts front and rear tape excess cleanly with high-frequency motors.' },
        { title: 'Radius Scraping Unit', text: 'Removes knife marks and fine glue traces for a smooth surface.' },
        { title: 'Buffing Station', text: 'Restores the original tape color and leaves a polished finish.' }
      ]
    },

    section2: {
      heading: 'Consistent Quality & Dependable Operation',
      description: 'Solid heavy frame minimizes vibration during high-speed feed belt transport.',
      bullets: [
        { title: 'Digital Temperature Controller', text: 'Maintains optimal glue viscosity for strong tape adhesion.' },
        { title: 'Pneumatic Control Valves', text: 'Ensures exact trimming pressure on sensitive panel surfaces.' },
        { title: 'Compact Footprint', text: 'Optimizes factory floor space utilization.' }
      ]
    },

    section3: {
      heading: 'Complete Edge Processing & Quality Finishing',
      description: 'Handles PVC, ABS, acrylic, and natural wood veneer tapes with high thermal bonding strength and uniform surface finishing.',
      bullets: [
        { title: 'Thermal Glue Adhesion', text: 'Consistent hot-melt application ensures durable bond integrity.' },
        { title: 'Profile Trimming & Buffing', text: 'Dual-motor buffing delivers seamless joint lines and satin finishes.' },
        { title: 'Versatile Tape Compatibility', text: 'Effortlessly bonds edge thicknesses from 0.4mm up to 3mm.' }
      ]
    }
  },

  // 7. Auto CNC Beam Saw (UBS 3200 Auto)
  'ubs-3200-auto': {
    slug: 'ubs-3200-auto',
    category: 'AUTO CNC BEAM SAW',
    title: 'Auto CNC Beam Saw UBS 3200 Auto',
    subtitle: 'High-Volume CNC Beam Sawing with Heavy-Duty Pusher Grippers.',
    mainImage: pro4,
    detailImage1: pro4,
    detailImage2: pro1,
    detailImage3: pro2,
    breadcrumb: 'HOME / PRODUCTS / CNC BEAM SAW / UBS 3200 AUTO',
    introHeading: 'Heavy-Duty Industrial Panel Processing Power.',
    introText1: 'The UBS 3200 Auto features pneumatic clamps, magnetic linear scales, and high-drive saw carriages for rapid multi-sheet cutting.',
    introText2: 'Engineered for large-scale panel manufacturers seeking maximum yield per sheet and minimal cycle time.',
    
    stickyCards: [
      {
        text: 'Precision servo-driven pusher grippers for accurate multi-sheet indexing.',
        title: 'High-Precision Cutting'
      },
      {
        text: 'Heavy tubular steel frame designed for non-stop industrial output.',
        title: 'Heavy-Duty Construction'
      },
      {
        fullWidth: true,
        text: 'Optimized nesting software integration reduces raw material scrap.',
        title: 'Production Efficiency'
      }
    ],

    section1: {
      heading: 'Pneumatic Gripper Pusher & Air Flotation Tables',
      description: 'Features air-cushioned front tables to prevent scratching delicate veneer and high-gloss panel surfaces.',
      bullets: [
        { title: 'Magnetic Encoder System', text: 'Provides real-time feedback for sub-millimeter positioning.' },
        { title: 'Air Floatation Tables', text: 'Allows operators to slide heavy panel stacks effortlessly.' },
        { title: 'Fast Carriage Return', text: 'Reduces cut cycle times during multi-pass sheet sizing.' }
      ]
    },

    section2: {
      heading: 'Industrial Reliability & Safety Features',
      description: 'Equipped with emergency stop safety curtains and automatic lubrication systems.',
      bullets: [
        { title: 'Safety Pressure Beams', text: 'Protects operators while securing sheet stacks.' },
        { title: 'Centralized Lubrication', text: 'Extends bearing life and lowers maintenance frequency.' },
        { title: 'Smart Diagnostic Screen', text: 'Displays machine status and maintenance alerts.' }
      ]
    },

    section3: {
      heading: 'High-Speed Multi-Layer Panel Processing',
      description: 'Engineered for heavy-duty industrial processing, accommodating dense sheet stacks with maximum cutting depth and automated material handling.',
      bullets: [
        { title: 'High-Capacity Stack Sizing', text: 'Simultaneous cutting of multiple boards for large manufacturing facilities.' },
        { title: 'Precision Gripper Positioning', text: 'Linear magnetic feedback maintains exact cut dimensions across long runs.' },
        { title: 'Automated Dust Extraction', text: 'Multi-point vacuum exhaust maintains blade cooling and clean workpiece surfaces.' }
      ]
    }
  },

  // Generic fallback generator for all other machine models
  defaultProduct: {
    slug: 'default',
    category: 'INDUSTRIAL MACHINERY',
    title: 'CNC Precision Machine Solution',
    subtitle: 'High-Speed Operation. Superior Build Quality. Maximum Output.',
    mainImage: hero1,
    detailImage1: pro2,
    detailImage2: pro3,
    detailImage3: pro4,
    breadcrumb: 'HOME / PRODUCTS / INDUSTRIAL CNC / PRECISION MACHINE',
    introHeading: 'Built for Precision. Designed for Production.',
    introText1: 'This high-performance industrial CNC machine delivers unmatched cutting accuracy, rapid operation, and industrial-grade stability designed for modern manufacturing facilities.',
    introText2: 'Engineered for seamless integration into automated production lines, offering low maintenance and superior operational productivity.',
    
    stickyCards: [
      {
        text: 'Accurate and consistent industrial output for demanding production applications.',
        title: 'High-Precision Performance'
      },
      {
        text: 'A robust machine structure engineered for stable operation and long-term durability.',
        title: 'Heavy-Duty Build'
      },
      {
        fullWidth: true,
        text: 'Automated CNC operation helps reduce manual intervention and optimize workflow efficiency.',
        title: 'Production Efficiency'
      }
    ],

    section1: {
      heading: 'High-Precision Cutting & Processing',
      description: 'Engineered to deliver smooth, accurate, and repeatable performance across diverse industrial materials.',
      bullets: [
        { title: 'CNC Automation', text: 'Precision digital control ensures repeatable tolerance and smooth edges.' },
        { title: 'High Production Capacity', text: 'Built to run continuously in heavy-duty factory environments.' },
        { title: 'Simplified Maintenance', text: 'Ergonomic component access reduces downtime during routine servicing.' }
      ]
    },

    section2: {
      heading: 'Robust Construction for Continuous Operation',
      description: 'Designed for demanding manufacturing environments, combining heavy steel framing with advanced servo drive systems for long-lasting reliability.',
      bullets: [
        { title: 'Heavy-Duty Frame', text: 'Eliminates vibration and ensures structural rigidity under heavy workloads.' },
        { title: 'Long-Term Reliability', text: 'Built for continuous production environments with premium components.' },
        { title: 'Stable Operation', text: 'Maintains consistent quality standards across high-volume production batches.' }
      ]
    },

    section3: {
      heading: 'Versatile Material Processing & Application',
      description: 'Designed to handle a diverse range of industrial materials with consistent accuracy, reliable operation, and high workflow efficiency.',
      bullets: [
        { title: 'Multi-Material Capability', text: 'Engineered for smooth processing of diverse industrial panel types and substrates.' },
        { title: 'Consistent Quality', text: 'Maintains uniform standards across variable batch sizes and continuous shifts.' },
        { title: 'Production Versatility', text: 'Easily adapts to changing manufacturing specifications and custom workpiece dimensions.' }
      ]
    }
  }
};

// Helper function to convert model names to clean URL slugs
export const formatSlug = (str) => {
  if (!str) return '';
  return str
    .toLowerCase()
    .trim()
    .replace(/\+\+/g, '-plus')
    .replace(/\+/g, '-plus')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

export const getProductBySlug = (slug) => {
  if (!slug) slug = 'ups-3200a';
  const formatted = slug.toLowerCase().trim();

  // 1. Direct key match in productsData
  let existingProduct = productsData[formatted];

  // 2. Specific matching for Panel Saw variations
  if (!existingProduct) {
    if (
      formatted.includes('3200a-plus') || 
      formatted.includes('3200-a-plus') || 
      formatted.includes('3200a++') || 
      formatted.includes('3200-a++') ||
      formatted.includes('plus')
    ) {
      existingProduct = productsData['ups-3200a-plus'];
    } else if (
      formatted.includes('3200a-hv') || 
      formatted.includes('3200-a-hv') || 
      formatted.includes('3200a.hv') ||
      formatted.includes('hv')
    ) {
      existingProduct = productsData['ups-3200a-hv'];
    } else if (
      formatted.includes('3200a') || 
      formatted.includes('3200-a')
    ) {
      existingProduct = productsData['ups-3200a'];
    }
  }

  // 3. Find category and model info from categoriesData
  let matchedCategory = null;
  let matchedModel = null;

  for (const key in categoriesData) {
    const cat = categoriesData[key];
    if (cat.models) {
      const model = cat.models.find(m => 
        m.slug.toLowerCase().trim() === formatted ||
        m.id.toLowerCase().trim() === formatted ||
        formatSlug(m.name) === formatted
      );
      if (model) {
        matchedCategory = cat;
        matchedModel = model;
        break;
      }
    }
  }

  if (matchedModel && !existingProduct) {
    existingProduct = productsData[matchedModel.slug] || productsData[matchedModel.id];
  }

  // Derive Category Name (Upper)
  let categoryNameUpper = 'PANEL SAW MACHINE';
  if (matchedCategory) {
    categoryNameUpper = matchedCategory.breadcrumb
      ? matchedCategory.breadcrumb.replace(/^HOME\s*\/\s*PRODUCTS\s*\/\s*/i, '').trim()
      : matchedCategory.title.replace(/ Machines$/i, '').toUpperCase();
  } else if (existingProduct && existingProduct.category) {
    categoryNameUpper = existingProduct.category.toUpperCase();
  }

  // Derive Product Name
  let displayTitle = '';
  if (existingProduct && existingProduct.title) {
    displayTitle = existingProduct.title;
  } else if (matchedModel && matchedModel.name) {
    displayTitle = matchedModel.name;
  } else {
    displayTitle = formatted.toUpperCase().replace(/-/g, ' ');
  }

  const productNameUpper = displayTitle.toUpperCase();
  const dynamicBreadcrumb = 'HOME / PRODUCTS / ' + categoryNameUpper + ' / ' + productNameUpper;
  const displayImage = matchedModel ? matchedModel.image : (existingProduct ? existingProduct.mainImage : hero1);

  if (existingProduct) {
    return {
      ...existingProduct,
      title: displayTitle,
      breadcrumb: dynamicBreadcrumb,
      mainImage: existingProduct.mainImage || displayImage,
      detailImage1: existingProduct.detailImage1 || displayImage,
      detailImage2: existingProduct.detailImage2 || displayImage,
      detailImage3: existingProduct.detailImage3 || displayImage,
      section1: existingProduct.section1 || productsData.defaultProduct.section1,
      section2: existingProduct.section2 || productsData.defaultProduct.section2,
      section3: existingProduct.section3 || productsData.defaultProduct.section3
    };
  }

  // Fallback product object with dynamic category breadcrumb and details
  return {
    ...productsData.defaultProduct,
    slug: formatted,
    title: displayTitle,
    breadcrumb: dynamicBreadcrumb,
    mainImage: displayImage,
    detailImage1: displayImage,
    detailImage2: displayImage,
    detailImage3: displayImage,
    introHeading: 'Engineered for ' + displayTitle + ' Output & Precision.',
    introText1: 'The ' + displayTitle + ' delivers industrial-grade accuracy and continuous output designed for modern panel processing and manufacturing facilities.',
    introText2: 'Built with heavy-duty framing and high-precision components to ensure smooth long-term operation.'
  };
};
